import { QueryClient } from "@tanstack/react-query";

/**
 * The single app-wide TanStack Query client.
 *
 * Lives in its own module (not main.tsx) so non-component code — notably the
 * auth store — can import it to clear cached query data on login/logout. The
 * cache MUST be cleared when the authenticated identity changes: a role switch
 * (e.g. superadmin ↔ dealer) is a client-side navigation, not a full reload, so
 * without an explicit clear the new user would keep seeing the previous user's
 * cached tenant/billing data until a manual refresh (cross-account data bleed).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
